import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { CircleCheckBig } from 'lucide-react';
import Loader from 'components/Loader';

const ChooseYourGoal = ({ options, selectedGoal, onSelect, isLoading }) => {
  if (isLoading) {
    return (
      <div className="lower-ltv-modal__goal-picker">
        <Loader className="height-1 mb-1" />
      </div>
    );
  }

  if (!options.length) {
    return null;
  }

  return (
    <div className="lower-ltv-modal__goal-picker">
      <div className="lower-ltv-modal__goal-picker-grid">
        {options.map((option) => {
          const isSelected = option.key === selectedGoal;

          return (
            <button
              key={option.key}
              type="button"
              className={cn(
                'lower-ltv-modal__goal-card',
                isSelected && 'lower-ltv-modal__goal-card--selected'
              )}
              onClick={() => onSelect(option.key)}
              aria-pressed={isSelected}
            >
              {isSelected && (
                <span className="lower-ltv-modal__goal-card-check" aria-hidden="true">
                  <CircleCheckBig size={20} strokeWidth={2.2} />
                </span>
              )}
              <span className="lower-ltv-modal__goal-card-label">{option.label}</span>
              <span className="lower-ltv-modal__goal-card-amount">{option.displayAmount}</span>
              <span className="lower-ltv-modal__goal-card-description">{option.description}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

ChooseYourGoal.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
    displayAmount: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    paymentAmount: PropTypes.number,
  })).isRequired,
  selectedGoal: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

ChooseYourGoal.defaultProps = {
  isLoading: false,
};

export default ChooseYourGoal;
